// Ricaricare la pagina: l'unico punto dell'applicazione che lo fa, per l'errore del telefono del browser che non si carica dopo
// un aggiornamento («Confermate l'8 ottobre 2026, dopo la prova del Power Dialer»). Un modulo a sé, così i test lo sostituiscono
// (`location.reload` di jsdom non si spia).
export function reloadPage(): void {
  window.location.reload();
}
